var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shape_2",
    d: "M13 25C5.8203 25 0 19.4036 0 12.5C0 5.59644 5.8203 0 13 0C20.1797 0 26 5.59644 26 12.5C26 19.4036 20.1797 25 13 25ZM10.107 7.07864L15.7452 12.5L10.107 17.9214C9.63101 18.379 9.63101 19.121 10.107 19.5786C10.5829 20.0363 11.3546 20.0363 11.8305 19.5786L18.3305 13.3286C18.8065 12.871 18.8065 12.129 18.3305 11.6714L11.8305 5.42136C11.3546 4.96371 10.5829 4.96371 10.107 5.42136C9.63101 5.879 9.63101 6.621 10.107 7.07864Z",
    fill: "#8F8F8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow1.1c2f0f8515379fc8167a92f285a88b76.svg";
export { ForwardRef as ReactComponent };